import React from 'react';
import OfferingsSection from '../components/OfferingsSection';

const Offerings = () => {
  return (
    <main className="offerings-page">
      <OfferingsSection />
    </main>
  );
};

export default Offerings;

